import { RefObject } from 'react';

import { FormMessageType } from '@gn-audio/jss-core/common/enums';
import { BaseFormMessage } from '@gn-audio/jss-core/common/models';

export const handleFormMessage = <T extends FormMessageType>(
  messageType: T,
  callback: (event: MessageEvent<BaseFormMessage>) => void
) => {
  return (event: MessageEvent<BaseFormMessage>) => {
    if (event.data.type === messageType) {
      callback(event);
    }
  };
};

export const postFormSubmit = (iframeRef: RefObject<HTMLIFrameElement>, data: any) => {
  if (!iframeRef.current) {
    return;
  }

  const iframe = iframeRef.current;
  iframe.contentWindow?.postMessage(
    {
      type: FormMessageType.Submit,
      data: data,
    },
    '*'
  );
};

export const setFormControlValue = (
  iframeRef: RefObject<HTMLIFrameElement>,
  controlName: string,
  value: unknown,
  propertyName: string = 'value'
) => {
  if (!iframeRef.current) {
    return;
  }

  const iframe = iframeRef.current;
  iframe.onload = () => {
    iframe.contentWindow?.postMessage(
      {
        type: FormMessageType.SetControl,
        controlName,
        propertyName,
        value,
      },
      '*'
    );
  };
};
